import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  logo: {
    width: 146,
    height: 40,
    paddingTop: 40,
    paddingBottom: 40,
  },
});

export default styles;
